import 'components/desktop/Ingredient/Search/Components/SearchResultList/SearchResultList.scss';
import ArchiveResultListRow from 'components/desktop/Ingredient/Search/Components/SearchResultListRow/ArchiveResultListRow';
import SearchResultListRow from 'components/desktop/Ingredient/Search/Components/SearchResultListRow/SearchResultListRow';
import * as Ingredient from 'types/Ingredient/Search/Ingredient';
import * as IngredientList from 'types/Ingredient/Search/IngredientList';

interface IProps {
	archive: boolean;
	handleArchiveIngredient: (input: string) => Promise<void>;
	handleRestoreIngredient: (input: string) => Promise<void>;
	ingredientList: IngredientList.Type;
}

const SearchResultList = (props: IProps) => {
	return (
		<div className="row-gy-4">
			<div className="col-lg-12">
				{props.archive ? (
					<>
						{props.ingredientList.map((obj: Ingredient.Type, i: number) => {
							return (
								<div key={i}>
									<ArchiveResultListRow
										handleRestoreIngredient={props.handleRestoreIngredient}
										ingredient={obj}
									/>
								</div>
							);
						})}
					</>
				) : (
					<>
						{props.ingredientList.map((obj: Ingredient.Type, i: number) => {
							return (
								<div key={i}>
									<SearchResultListRow
										handleArchiveIngredient={props.handleArchiveIngredient}
										ingredient={obj}
									/>
								</div>
							);
						})}
					</>
				)}
			</div>
		</div>
	);
};

export default SearchResultList;
